import React, { useState } from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import CommonService from '../../../../services/commonService';
import getIcons from '../../functions/getIcons/getIcons';

const tepualData = [
  {
    city: 'Salón-Cama',
    active: true,
    title: 'Buses Salón Cama',
    features: [
      { label: 'Capacidad de 28 a 43 pasajeros.' },
      { label: 'Televisión de 3 pantallas.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Wi-Fi.' },
      { label: 'Frazadas y almohadas.' },
      { label: 'Baño.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },
  {
    city: 'Semi-Cama',
    title: 'Buses Semi-Cama',
    features: [
      { label: 'Capacidad de 64 pasajeros.' },
      { label: 'Televisión de 3 pantallas.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Baño.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },

  {
    city: 'Buses mixtos',
    title: 'Buses mixtos',

    features: [
      { label: 'Capacidad de 56 pasajeros.' },
      { label: '12 asientos Cama, 44 Semi-Cama.' },
      { label: 'Televisión de 3 pantallas.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Baño.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },
  {
    city: 'Buses Pullman',
    title: 'Buses Pullman',
    features: [
      { label: 'Capacidad de 41 a 51 pasajeros.' },
      { label: 'Televisión de 3 pantallas.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Baño.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },
  {
    city: 'Mini buses',
    title: 'Mini buses',
    features: [
      { label: 'Capacidad para 9 pasajeros.' },
      { label: 'Asientos reclinables y paquetera.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },
  {
    city: 'Taxi buses',
    title: 'Taxi buses',
    features: [
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad.' },
    ],
  },
  {
    city: 'Vans',
    title: 'Vans',
    features: [
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Equipo monitoreado por GPS.' },
    ],
  },
];
const centraltourData = [
  {
    city: 'Salón-cama',
    active: true,
    title: 'Buses Salón Cama',
    features: [
      { label: 'Capacidad de 28 a 43 pasajeros.' },
      { label: 'Televisión de 3 pantallas.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Wi-Fi.' },
      { label: 'Frazadas y almohadas.' },
      { label: 'Baño.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },

  {
    city: 'Semi-cama',
    active: false,
    title: 'Buses Semi-cama',
    features: [
      { label: 'Capacidad de 64 pasajeros.' },
      { label: 'Televisión de 3 pantallas.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Baño.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },

  {
    city: 'Mini buses',
    active: false,
    title: 'Buses Mini buses',
    features: [
      { label: 'Capacidad para 9 pasajeros.' },
      { label: 'Asientos reclinables y paquetera.' },
      { label: 'Calefacción y aire acondicionado.' },
      { label: 'Equipo monitoreado por GPS.' },
      { label: 'Frazadas y almohadas.' },
      { label: 'Cinturones de seguridad de 3 puntas.' },
    ],
  },
];

const ThemeFiveFleetSection = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;
  const [selectedOffice, setSelectedOffice] = useState();
  const [offices, setOffices] = useState([]);

  useEffect(() => {
    const operator_name = operator.operator_name;

    if (operator_name === 'tepual') {
      setOffices(tepualData);
      setSelectedOffice(tepualData[0]);
    }

    if (operator_name === 'centraltour') {
      setOffices(centraltourData);
      setSelectedOffice(centraltourData[0]);
    }
  }, []);

  const getDynamicStyling = (item, index) => {
    if (item.active) {
      return {
        color: operator && operator.color_codes && operator.color_codes.secondary_color,
        background: operator && operator.color_codes && operator.color_codes.selected_off_bg,
      };
    }
    if (index % 2 === 0) {
      return {
        background: operator && operator.color_codes && operator.color_codes.primary_off_bg,
      };
    } else {
      return {
        background: operator && operator.color_codes && operator.color_codes.secondary_off_bg,
      };
    }
  };

  const onSelect = item => {
    const data = offices.map((val, i) => {
      val.active = val.title === item.title ? true : false;
      return val;
    });
    setOffices(data);
    setSelectedOffice(item);
  };
  return (
    <div className="themes-theme-five-fleet-section">
      <div className="new-container">
        <div className="offices">
          <ul
            className="office__list"
            style={{
              background: operator && operator.color_codes && operator.color_codes.selected_off_bg,
            }}
          >
            {offices.map((item, index) => (
              <li
                onClick={() => onSelect(item)}
                className="cursor-pointer  office__item"
                key={index}
                style={getDynamicStyling(item, index)}
              >
                <span
                  className="office__name font11"
                  style={
                    item.active
                      ? {
                          color:
                            operator &&
                            operator.color_codes &&
                            operator.operator_name === 'centraltour'
                              ? '#fff'
                              : operator.color_codes.secondary_off_bg,
                          borderBottom: `3px solid ${operator &&
                            operator.color_codes &&
                            operator.color_codes.secondary_off_bg}`,
                        }
                      : {
                          borderBottom: `3px solid ${operator &&
                            operator.color_codes &&
                            operator.color_codes.selected_off_bg}`,
                          color: operator.operator_name === 'expressonorte' ? '#000' : '#fff',
                        }
                  }
                >
                  {item.city}
                </span>
              </li>
            ))}
          </ul>
          <div className="office__map">
            <div className="office__map-view">
              <img
                src={getIcons('aboutUsOfficeImage', operator)}
                alt=""
                className="about-service-image"
              />
            </div>

            {selectedOffice && (
              <SelectedOffice selectedOffice={selectedOffice} operator={operator} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const SelectedOffice = ({ selectedOffice, operator }) => {
  return (
    selectedOffice && (
      <div className="selected">
        <div className="inner">
          <div
            className="title less-bold-text"
            style={{
              borderBottom: `3px solid ${operator &&
                operator.color_codes &&
                operator.color_codes.primary_color}`,
            }}
          >
            {selectedOffice.title ? selectedOffice.title : ''}
          </div>

          {selectedOffice && selectedOffice.features && selectedOffice.features.length
            ? selectedOffice.features.map((value, index) => {
                return (
                  <div key={index} className="label">
                    <span
                      style={{
                        backgroundColor:
                          operator && operator.color_codes && operator.color_codes.primary_color,
                        width: 8,
                        height: 2.5,
                        marginRight: 5,
                        display: 'flex',
                      }}
                    ></span>
                    <span>{value.label}</span>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    )
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

export default connect(mapStateToProps, {})(ThemeFiveFleetSection);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/components/ThemeFiveFleetSection.js